import { isBefore } from 'date-fns'
import { Checkpointable } from '../sagas/createCheckpoints'

type IsCheckpointable<T> = T extends Checkpointable ? T : never

export function sortCheckpointableEntities<T>(
  entities: IsCheckpointable<T>[]
): IsCheckpointable<T>[] {
  return entities.sort((a, b) => {
    if (isBefore(a.checkpointableDate, b.checkpointableDate)) {
      return 1
    }
    if (isBefore(b.checkpointableDate, a.checkpointableDate)) {
      return -1
    }
    return 0
  })
}
